<template>
  <a-timeline-item>
    <i :class="this.icon" slot="dot" style="font-size: 16px;"/>
    <slot>
      <span v-html="sanitizedDescription"></span><br/>
      <span class="small">{{ activity.created_at_readable }}</span>
    </slot>
  </a-timeline-item>
</template>

<script>

import icon from '~/util/icon';
import DOMPurify from 'dompurify';

export default {
  name: "ActivityTimelineComponent",
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return icon.iconClassByType(this.activity.linked_object_type || this.activity.icon_type);
    },
    sanitizedDescription() {
      return DOMPurify.sanitize(this.activity.description_html) || '';
    }
  }
}
</script>

<style scoped>
small {
  font-size: small;
}
</style>
